import createContext from 'contexts/create-context';
import * as React from 'react';

import type { OrderStatsEntry } from './endpoints/OrderStatsEndpoint.types';

export type DashboardEntry = OrderStatsEntry;

interface ProviderValue {
  entries: DashboardEntry[];
  refreshData: () => void;
  timeFrame?: {
    startDate: string;
    endDate: string;
  };
  dealOwnerID?: string | null;
  businessUnit?: string | null;
}

const [useContext, ReactProvider] = createContext<ProviderValue>();

interface IDashboardProviderProps {
  entries: DashboardEntry[];
  refreshData: () => void;
  children?: React.ReactNode;
  dealOwnerID?: string | null;
  businessUnit?: string | null;
  timeFrame?: {
    startDate: string;
    endDate: string;
  };
}

export const DashboardProvider: React.FC<IDashboardProviderProps> = (props) => {
  const { entries, children, refreshData, timeFrame, dealOwnerID, businessUnit } = props;
  // TODO: According to Gilles this shouldn't be filtered out
  // not sure why this was added in the first place
  // just double check with him if someone reports this as "broken"
  // const filteredEntries = React.useMemo(() => {
  //   return entries.filter((e) => !e.noPurchase);
  // }, [entries]);
  return (
    <ReactProvider value={{ entries, refreshData, timeFrame, dealOwnerID, businessUnit }}>{children}</ReactProvider>
  );
};

export const useDashboardContext = useContext;
